import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Filters } from '@cimplico/components';
type Sort = { order: 'asc' | 'desc'; option?: string };

export type WorkpaperFilterState = {
    value: { [key: string]: { [key: string]: { filter?: Filters; filterQuery?: string; sort?: Sort; sortQuery?: string; tab?: string } } };
};

const initialState: WorkpaperFilterState = {
    value: {},
};

export const workpaperFilterSlice = createSlice({
    name: 'workpaper-filters',
    initialState,
    reducers: {
        saveFilter: (state, action: PayloadAction<{ workpaperId: string; section: string; filters: Filters; qs: string }>) => {
            const { workpaperId, section, filters, qs } = action.payload;

            if (!state.value[workpaperId]) {
                state.value[workpaperId] = {};
            }
            if (!state.value[workpaperId][section]) {
                state.value[workpaperId][section] = {};
            }
            state.value[workpaperId][section].filter = filters;
            state.value[workpaperId][section].filterQuery = qs;
        },

        saveFilterV2: (state, action: PayloadAction<{ workpaperId: string; section: string; query: string }>) => {
            const { workpaperId, section, query } = action.payload;
            if (!state.value[workpaperId]) {
                state.value[workpaperId] = {};
            }
            if (!state.value[workpaperId][section]) {
                state.value[workpaperId][section] = {};
            }

            state.value[workpaperId][section].filterQuery = query;
        },

        saveTab: (state, action: PayloadAction<{ workpaperId: string; section: string; tab: string }>) => {
            const { workpaperId, section, tab } = action.payload;

            if (!state.value[workpaperId]) {
                state.value[workpaperId] = {};
            }
            if (!state.value[workpaperId][section]) {
                state.value[workpaperId][section] = {};
            }

            state.value[workpaperId][section].tab = tab;
        },

        saveSort: (state, action: PayloadAction<{ workpaperId: string; section: string; sort: Sort; qs: string }>) => {
            const { workpaperId, section, sort, qs } = action.payload;
            if (!state.value[workpaperId]) {
                state.value[workpaperId] = {};
            }
            if (!state.value[workpaperId][section]) {
                state.value[workpaperId][section] = {};
            }

            state.value[workpaperId][section].sort = sort;
            state.value[workpaperId][section].sortQuery = qs;
        },
        saveSortV2: (state, action: PayloadAction<{ workpaperId: string; section: string; query: string }>) => {
            const { workpaperId, section, query } = action.payload;
            if (!state.value[workpaperId]) {
                state.value[workpaperId] = {};
            }
            if (!state.value[workpaperId][section]) {
                state.value[workpaperId][section] = {};
            }

            state.value[workpaperId][section].sortQuery = query;
        },
        del: (state, action: PayloadAction<{ workpaperId: string }>) => {
            delete state.value[action.payload.workpaperId];
        },
    },
});

// Action creators are generated for each case reducer function
export const { saveFilter, saveSort, del, saveFilterV2, saveSortV2, saveTab } = workpaperFilterSlice.actions;

export default workpaperFilterSlice.reducer;
